import config from '@nerdwallet/app-config';
import createCache from './createCache';
import { resolvers } from './local-schemas';

export const APOLLO_URI =
  config?.API?.BASE_URLS?.SUPERGRAPH ||
  'https://www.nerdwallet.com/api/supergraph';

export const APP_NAME = config?.CLIENT_ID || 'compass';

/**
 * Empty object literals are necessary for using the Apollo client cache in the future.
 * Any local state management via apollo client via the @client directive should add
 * defaults and, if necessary, a resolver for the data types being read/written
 */
export default {
  connectToDevTools: config?._meta?.environment === 'dev',
  createCache,
  defaults: {},
  environment: config?._meta?.environment || 'production',
  name: APP_NAME,
  resolvers,
  supergraphURL: APOLLO_URI,
  version: config?._meta?.version,
};
